<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-4 align-self-center breakWord">
      <h2> {{
                  versiondetails && versiondetails.fileName
                    ? versiondetails.fileName
                    : docDetails && docDetails.name
                    ? docDetails.name
                    : NewFile
                }}</h2>
    </div>
    <div
      class="col-8 d-flex align-items-center gap-1 justify-content-end ms-auto px-0"
    >
      <!-- Approve Button (conditionally shown) -->
      <!-- Reviewer button -->

      <div class="me-2 assign-qc">
        <img
          v-if="
            qcReviewApprovalStatus &&
            qcReviewApprovalStatus.reviewerCount == 0 &&
            signstatus != 'completed' &&
            completionStatus != 'Completed' &&
            (!currentProcess || currentProcess === 'DocReview')
          "
          src="../../assets/img/assign_reviewer.svg"
          alt="Assign QC"
          :class="{ 'disabled-img': showLoading }"
          @click="!showLoading && openApprovalModal('review')"
        />
        <div class="tool-tip" v-if="!showLoading">Assign Reviewer</div>
      </div>

      <!-- <div class="me-2 assign-qc">
       <img
          v-if="
          qcReviewApprovalStatus &&
          qcReviewApprovalStatus.reviewerCount == 0 &&
          signstatus != 'completed' &&
          completionStatus != 'Completed' &&
          (!currentProcess || currentProcess === 'DocReview') &&
          (presentPage === 'folder' ||
          presentPage === 'folderDocLogin' ||
          (presentPage === 'etmf' && canSelectReviewers))
              "
              src="../../assets/img/assign_reviewer.svg"
              alt="Assign QC"
              :class="{ 'disabled-img': showLoading }"
              @click="!showLoading && openApprovalModal('review')"
            />

        <div class="tool-tip" v-if="!showLoading">Assign Reviewer</div>
      </div> -->
      <!-- QC button -->
      <div class="me-2 assign-qc">
        <img
          v-if="
            qcReviewApprovalStatus &&
            qcReviewApprovalStatus.qcCount == 0 &&
            signstatus != 'completed' &&
            completionStatus != 'Completed' &&
            (!currentProcess || currentProcess === 'DocQC')
          "
          src="../../assets/img/assign_qc.svg"
          alt="Assign QC"
          :class="{ 'disabled-img': showLoading }"
          @click="!showLoading && openApprovalModal('qc')"
        />
        <div class="tool-tip" v-if="!showLoading">Assign QC</div>
      </div>
      <!-- Approver button -->
      <div class="me-2 assign-approver">
        <img
          v-if="
            qcReviewApprovalStatus &&
            qcReviewApprovalStatus.approvalCount == 0 &&
            signstatus != 'completed' &&
            completionStatus != 'Completed' &&
            (!currentProcess || currentProcess === 'DocApproval') 
          "
          src="../../assets/img/assign_approver.svg"
          alt="Assign Approver"
          :class="{ 'disabled-img': showLoading }"
          @click="!showLoading && openApprovalModal('approval')"
        />
        <div class="tool-tip" v-if="!showLoading">Assign Approver</div>
      </div>
      <div class="me-2 add-signers">
        <img
          v-if="
            !versiondetails.isSignConfig &&
            !issigned &&
            canSelectSigners &&
            completionStatus != 'Completed'
          "
          src="../../assets/img/assign_signers.svg"
          alt="Assign Signers"
          :class="{ 'disabled-img': showLoading }"
          @click.prevent="!showLoading && openDocRecipientModal()"
        />
        <div class="tool-tip" v-if="!showLoading">Assign Signers</div>
        <!-- Approve Button (conditionally shown) -->
      </div>
      <div class="me-2 add-signers">
        <img
          src="../../assets/img/assign_tick.svg"
          alt="Assign Signers"
          v-if="
           
            canCompleteDocument &&
            completionStatus != 'Completed'
          "
          :class="{ 'disabled-img': showLoading }"
          @click.prevent="!showLoading && CompleteDocument('Completed')"
        />
        <div class="tool-tip" v-if="!showLoading">Complete Document</div>
        <!-- Approve Button (conditionally shown) -->
      </div>
      <!-- Close Button -->
      <button
        class="border-0 bg-transparent p-0 tooltip-wrapper"
        @click="previousPage()"
      >
        <i class="fa fa-times close-button-popups"></i>
        <span
          class="custom-tooltip-popups tooltip-below-icon position-absolute start-50 translate-middle-x mt-1"
          >Close</span
        >
      </button>
    </div>
  </div>

   <div
    v-if="
      presentPage === 'folderDocLogin' &&
      (showValue == 'Pending' ||
        showValue == 'Approved' ||
        showValue == 'Rejected' ||
        showValue == 'Completed')
    "
    
  >
    <!-- <div class="row" v-if="showValue == 'Pending'">
      <div class="form-group col-md-10 mb-0">
        <input
          type="text"
          placeholder="Comments"
          class="form-control w-100"
          v-model="comments"
        />
      </div>
      <div class="col-md-2 d-flex justify-content-between gap-1">
        <button
          type="button"
          class="btn btn-outline-primary w-100 mb-2 py-0"
          @click="ApprovalStatus(true)"
        >
          {{ approveButtonLabel }}
        </button>

        <button
          type="button"
          class="btn btn-outline-danger w-100 mb-2 py-0"
          @click="ApprovalStatus(false)"
        >
          Reject
        </button>
      </div>
    </div> -->
    <!-- <div class="row" v-if="showValue == 'Approved'">
      <div class="col-md-2">
        <p class="badge badge-primary px-2 py-1 mb-0">Approved</p>
      </div>
      <div class="form-group col-md-10">
        <td>
          <strong>{{ $t("navigations.comments") }} :</strong>
          {{ approvaldetails.comments }}
        </td>
      </div>
    </div>
    <div class="row" v-if="showValue == 'Completed'">
      <div class="col-md-2">
        <p class="badge badge-primary px-2 py-1 mb-0">Completed</p>
      </div>
      <div class="form-group col-md-10">
        <td>
          <strong>{{ $t("navigations.comments") }} :</strong>
          {{ approvaldetails.comments }}
        </td>
      </div>
    </div> -->
    <!-- approved document end-->
    <!-- rejected document start-->
    <div class="row" v-if="showValue == 'Rejected'">
      <div class="col-md-2">
        <p class="badge badge-danger px-2 py-1 mb-0">Rejected</p>
      </div>
      <div class="form-group col-md-10">
        <td>
          <strong>{{ $t("navigations.comments") }} :</strong>
          {{ approvaldetails.comments }}
        </td>
      </div>
    </div>
  </div>

  <div class="d-flex gap-1">
    <div :class="showdocsigniframe || maximized ? 'col-lg-12 px-0' : 'col-lg-8 px-0'">
      <div class="ibox-title style_2 mt-2 mb-0">
        <!-- <div class="ibox-tools">
          <div> {{ statuses.reviewed.email }} ,..., {{ statuses.reviewed.status }}</div>
          <div> {{ statuses.reviewed.actionTime }}</div>
        </div> -->
        <div class="ibox-tools">
          <button
            v-if="statuses.reviewed.email == loggedinUser.email && statuses.reviewed.status == 'Pending'"
            class="etmf-btn cursor-pointer py-0 px-2 mr-2"
            type="button"
            @click="ActionClicked('review')"
          >
            <div class="d-flex align-items-center">
              <span class="custom-badge badge-warning status-b-radius mr-1"></span>
              <div> Review </div>
            </div>
          </button>
         <button
            v-if="statuses.reviewed.email == loggedinUser.email && statuses.reviewed.status != 'Pending'&& signstatus != 'completed'" 
            :disabled="true"
            class="etmf-btn cursor-pointer py-0 px-2 mr-2 tooltip-btn"
            type="button"
        >
            <div class="d-flex align-items-center">
              <span class="custom-badge status-b-radius mr-1"
              :class="{
                'badge-grn': statuses.reviewed.status === 'Reviewed',
                'badge-danger': statuses.reviewed.status === 'Rejected'
            }"
              
              ></span>
              <div> Review </div>
            </div>
            <span class="tooltip-text">
               Status: {{ statuses.reviewed.status }} | {{  statuses.reviewed.actionTime }}
            </span>
        </button>
        

         <button
            v-if="statuses.qced.email == loggedinUser.email && statuses.qced.status == 'Pending'"
            class="etmf-btn cursor-pointer py-0 px-2 mr-2"
            type="button"
            @click="ActionClicked('qc')"
          >
            <div class="d-flex align-items-center">
              <span class="custom-badge badge-warning status-b-radius mr-1"
              ></span>
              <div> QC </div>
            </div>
          </button>
          <button
              v-if="statuses.qced.email == loggedinUser.email && statuses.qced.status != 'Pending'"
              :disabled="true"
              class="etmf-btn cursor-pointer py-0 px-2 mr-2 tooltip-btn"
              type="button"
          >
              <div class="d-flex align-items-center">
                <span class="custom-badge status-b-radius mr-1"
                :class="{
                'badge-grn': statuses.qced.status === 'QCed',
                'badge-danger': statuses.qced.status === 'Rejected'
            }"
                ></span>
                <div> QC </div>
              </div>
              <span class="tooltip-text">
               Status: {{ statuses.qced.status }} | {{  statuses.qced.actionTime }}

              </span>
          </button>

           <button
            v-if="statuses.approved.email == loggedinUser.email && statuses.approved.status == 'Pending'"
            class="etmf-btn cursor-pointer py-0 px-2 mr-2"
            type="button"
            @click="ActionClicked('approval')"
          >
            <div class="d-flex align-items-center">
              <span class="custom-badge badge-warning status-b-radius mr-1"></span>
              <div> Approve </div>
            </div>
          </button>
          <button
              v-if="statuses.approved.email == loggedinUser.email && statuses.approved.status != 'Pending'"
              :disabled="true"
              class="etmf-btn cursor-pointer py-0 px-2 mr-2 tooltip-btn"
              type="button"
          >
              <div class="d-flex align-items-center">
                <span class="custom-badge status-b-radius mr-1"
                :class="{
                'badge-grn': statuses.approved.status === 'Approved',
                'badge-danger': statuses.approved.status === 'Rejected'
            }"
                ></span>
                <div> Approve </div>
              </div>
              <span class="tooltip-text">
                Status: {{ statuses.approved.status }} | {{  statuses.approved.actionTime }}
              </span>
          </button>
          <button
  class="etmf-btn cursor-pointer py-0 px-2 mr-2"
  type="button"
  v-if="statuses.signed.email == loggedinUser.email"
  @click="gotodocumentsign(statuses.signed.email, statuses.signed.recipientSignOrder)"
  :disabled="statuses.signed.completed"
  :data-tooltip="statuses.signed.completed ? 'e-Signed on: ' + statuses.signed.timestamp : ''"
>
  <div class="d-flex align-items-center">
    <span
      class="custom-badge status-b-radius mr-1 "
        :class="{
        'badge-grn': statuses.signed.status === 'completed',   
        'badge-warning': statuses.signed.status !== 'completed',}"
      
    ></span>
    <div>{{ statuses.signed.completed ? 'e-Signed' : 'e-Sign' }}</div>
  </div>
</button>
<a v-if="maximized == false && !showdocsigniframe" @click="maximizeorminimise(true)"><img width="20" src="../../assets/img/icons/maximize.png" alt="maximize"></a>
<a v-if="maximized == true && !showdocsigniframe" @click="maximizeorminimise(false)"><img width="20" src="../../assets/img/icons/minimize.png" alt="maximize"></a>



        </div>
      </div>
      
      <div class="ibox-content p-1 relative-container">
        <!-- ⬅️ add class -->

        <!-- 📄 Document Loading Overlay -->
        <div v-if="!showdocsigniframe && isDocLoading" class="loader-overlay">
          <div class="spinner"></div>
          <p class="loader-text">Loading document…</p>
        </div>
        <!-- Images -->
        <div
          v-if="!showdocsigniframe"
          class="wrapper wrapper-content animated fadeInRight"
        >
          <div v-if="['jpg', 'jpeg', 'png'].includes(formatLower)">
            <img
              :src="source"
              alt=""
              class="imgwidth"
              @load="onImageLoad"
              @error="onDocError"
            />
          </div>
        </div>
        <!-- PDF -->
        <div
          v-if="!showdocsigniframe || !maximized"
          class="wrapper wrapper-content animated fadeInRight"
        >
          <div v-if="formatLower === 'pdf'" class="pdfembeded">
            <vue-pdf-embed
              :source="source"
              @loaded="onPdfLoaded"
              @error="onDocError"
            />
          </div>

          <!-- Office -->
          <div class="row" v-if="!showdocsigniframe">
            <div v-if="office.includes(formatLower)" class="outsideframerrr">
              <iframe
                :src="officeurl"
                width="100%"
                height="650px"
                frameborder="0"
                @load="onOfficeLoad"
              ></iframe>
            </div>
          </div>
        </div>
        <div
          v-if="showdocsigniframe"
          class="wrapper wrapper-content animated fadeInRight"
        >
          <div v-if="showdocsigniframe" class="relative-container">
            <!-- ⬅️ ensure relative -->
            <!-- ✍️ DocuSign Loading Overlay -->
            <div v-if="isSignLoading" class="loader-overlay">
              <div class="spinner"></div>
              <p class="loader-text">Loading signing session…</p>
            </div>

            <iframe
              v-if="showdocsigniframe"
              ref="dsFrame"
              :src="docsignurl"
              width="100%"
              height="650"
              frameborder="0"
              @load="onDocuSignFrameLoad"
            />
          </div>
        </div>
        <!-- <div v-if="office.includes(format)" class="outsideframe">
      <iframe :src="officeurl" width="100%" height="650px" frameborder="0"></iframe>
    </div> -->
      </div>
    </div>
    <div v-if="!showdocsigniframe" class="col-lg-4 mt-2 px-0">
      <div class="ibox-title style_2 px-3 m-0 py-1">
        <h4 class="align-self-center mb-0 mt-2">Document Details</h4>
      </div>
      <div class="ibox-content">
        <table class="table table-responsive table-bottom small">
          <tbody>
            <tr>
              <td class="p-1">
                <strong>Document Name :</strong>
                {{
                  versiondetails && versiondetails.fileName
                    ? versiondetails.fileName
                    : docDetails && docDetails.name
                    ? docDetails.name
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Document Title :</strong>
                {{
                  docDetails && docDetails.documentTitle
                    ? docDetails.documentTitle
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Artifact Name :</strong>
                {{
                  docDetails && docDetails.artifactName
                    ? docDetails.artifactName
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Completion Date :</strong>
                {{
                  docDetails && docDetails.completionDate
                    ? docDetails.completionDate
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Uploaded by :</strong>
                {{
                  versiondetails && versiondetails.createdUserName
                    ? versiondetails.createdUserName
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Uploaded Date :</strong>
                {{
                  versiondetails && versiondetails.createdAt
                    ? versiondetails.createdAt
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Document Date :</strong>
                {{
                  versiondetails && versiondetails.createdAt
                    ? versiondetails.createdAt
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Expiry Date :</strong>
                {{
                  docDetails && docDetails.expiryDate
                    ? docDetails.expiryDate
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Study :</strong>
                {{
                  docDetails && docDetails.studyRef ? docDetails.studyRef : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Country :</strong>
                {{
                  docDetails && docDetails.country ? docDetails.country : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Site :</strong>
                {{
                  docDetails && docDetails.siteCode ? docDetails.siteCode : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Owner :</strong>
                {{ docDetails && docDetails.owner ? docDetails.owner : "—" }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Version :</strong>
                {{
                  versiondetails && versiondetails.version
                    ? versiondetails.version
                    : "—"
                }}
              </td>
            </tr>

            <tr>
              <td class="p-1">
                <strong>Document Status :</strong>
                {{
                  docDetails && docDetails.documentStatus
                    ? docDetails.documentStatus
                    : "—"
                }}
              </td>
            </tr>

            <!-- Approvals -->
            <template
              v-if="
                versiondetails &&
                Array.isArray(versiondetails.approval) &&
                versiondetails.approval.length
              "
            >
              <tr
                v-for="(approval, i) in versiondetails.approval"
                :key="
                  approval.approvalTypeID || approval.assignedByUsername || i
                "
              >
                <td class="p-1">
                  <strong>Approver Name :</strong>&nbsp;
                  <span>{{ approval.approvedByUsername || "—" }}</span>
                </td>
                <td class="p-1">
                  <strong>Approval Status :</strong>&nbsp;
                  <span>{{ approval.approvedStatus || "—" }}</span>
                  <i
                    v-if="approval.approvedStatus!='Pending'"
                    class="fa fa-commenting-o text-primary ml-2 cursor-pointer"
                    @click="openApprovalDetailModal(approval)"
                  ></i>
                </td>
                <!-- <td class="p-1">
                  <i class="fa fa-commenting-o" aria-hidden="true"></i>
                </td> -->
              </tr>
            </template>
            <tr v-else>
              <td class="p-1" colspan="2">
                <strong>No approvers assigned </strong>
              </td>
            </tr>

            <!-- Reviewers -->
            <template
              v-if="
                versiondetails &&
                Array.isArray(versiondetails.reviewer) &&
                versiondetails.reviewer.length
              "
            >
              <tr
                v-for="(reviewer, i) in versiondetails.reviewer"
                :key="reviewer.approvalTypeID || i"
              >
                <td class="p-1">
                  <strong>Reviewer Name :</strong>&nbsp;
                  <span>{{ reviewer.reviewedByUsername || "—" }}</span>
                </td>
                <td class="p-1">
                  <strong>Review Status :</strong>&nbsp;
                  <span>{{ reviewer.reviewedStatus || "—" }}</span>
                  <i
                    v-if="reviewer.reviewedStatus!='Pending'"
                    class="fa fa-commenting-o text-primary ml-2 cursor-pointer"
                    @click="openReviewerDetailModal(reviewer)"
                  ></i>
                </td>
                
              </tr>
            </template>
            <tr v-else>
              <td class="p-1" colspan="2">
                <strong>No reviewer assigned</strong>
              </td>
            </tr>

            <!-- QC -->
            <template
              v-if="
                versiondetails &&
                Array.isArray(versiondetails.qc) &&
                versiondetails.qc.length
              "
            >
              <tr
                v-for="(qc, i) in versiondetails.qc"
                :key="qc.approvalTypeID || i"
              >
                <td class="p-1">
                  <strong>QC Name :</strong>&nbsp;
                  <span>{{ qc.qcByUsername || "—" }}</span>
                </td>
                <td class="p-1">
                  <strong>QC Status :</strong>&nbsp;
                  <span>{{ qc.qcStatus || "—" }}</span>
                  <i
                    v-if="qc.qcStatus!='Pending'"
                    class="fa fa-commenting-o text-primary ml-2 cursor-pointer"
                    @click="openQcDetailModal(qc)"
                  ></i>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td class="p-1" colspan="2">
                <strong>No QC person assigned</strong>
              </td>
            </tr>
            <!-- Signers -->
            <template v-if="docusigndata.length != 0">
              <tr v-for="user in docusigndata" :key="user.recipientUserId">
                <td class="p-1">
                  <strong>Signer Name :</strong>
                  <span>{{ user.recipientName || "—" }}</span>
                </td>
                <td class="p-1">
                  <strong>e-Sign Status :</strong>
                  <span>{{
                    datacorrected[user.recipientStatus]
                      ? datacorrected[user.recipientStatus]
                      : "—"
                  }}</span>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td class="p-1" colspan="2">
                <strong>No signers assigned </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="ibox-title style_2 d-flex justify-content-between px-3 py-1 mt-1"
      >
        <h4 class="align-self-center mb-1">Version History</h4>
        <div
          v-if="canUpload"
          class="position-relative my-0 py-0 align-self-center"
        >
          <!-- v-if="!checkstatusvalue.includes(showValue)" -->
          <img
            class="cursor-pointer"
            src="../../assets/img/create.png"
            alt="create version"
            width="20"
            @click="NewDocVersion()"
          />

          <div class="tool-tip">Add new version</div>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-responsive small m-b-xs">
          <thead>
            <tr>
              <th width="15%">Name</th>
              <th width="15%">Version</th>
              <th width="20%">Date</th>
              <th width="40%">Version Changes</th>
              <th width="10%" class="text-center">View</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(version, index) in versionList.slice(0, 30)"
              :key="version.projectid"
               :class="{ 'bg-light': selectedversionid === version.version }"
            >
>
        <td class="breakWord">
          <span v-if="!readMore[index]">
            {{ version.fileName.substring(0, 15) + ".." }}
            <span @click="toggleRead(index)" class="more">More</span>
          </span>

          <span v-else>
            {{ version.fileName }}
            <span @click="toggleRead(index)" class="less">Less</span>
          </span>
        </td>

              <td>{{ version.version }}</td>
              <td>
                {{ version.createdAt ? version.createdAt.slice(0, 10) : "" }}
              </td>
              <td>{{ version.versionMessage }}</td>
              <td class="text-center">
                <a
                  @click.prevent="
                    versionViewer(
                      version.versionId,
                      version.versionType,
                      version.version
                    )
                  "
                  ><i class="fa fa-eye"></i
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <customModal
    v-if="documentApprovalModal == true"
    :containermd="true"
    :footerShow="true"
    @closeModal="closeDocumentApprovalModal()"
  >
    <template #title>
      <span v-if="selectedApprovalType === 'approval'">Assign Approvers</span>
      <span v-else-if="selectedApprovalType === 'qc'">Assign QC</span>
      <span v-else-if="selectedApprovalType === 'review'">Assign Reviewers</span
      >
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
          <label class="">{{ $t("navigations.choose role") }}</label>
          <Multiselect
            v-model="designationList"
            mode="multiple"
            :searchable="true"
            trackBy="role_Name"
            valueProp="id"
            placeholder="Select"
            label="role_Name"
            :options="roleList"
            :hideSelected="false"
            :closeOnSelect="false"
            class="multiselect-template-theme mr-0 mt-1"
            @change="onChange"
          />
        </div>
        <!--  New Date Input -->
        <div class="col-6">
          <label class="">{{ $t("navigations.due date") }}</label>
          <input type="date" class="form-control" v-model="selectedDueDate" />
        </div>
      </div>
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input
                  class="mr-1"
                  type="checkbox"
                  id="selectAllDocumentApprovers"
                  @change="selectall()"
                />
                Users
              </th>
              <th></th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in userList" :key="user.id">
              <td width="50%">
                <input
                  class="mr-1"
                  type="checkbox"
                  :value="user.name"
                  :id="user.userID"
                  :name="user.name"
                  v-model="isSelectedUser[index]"
                  @change="addApprover(user, index)"
                  :checked="userobject[user.userId]"
                  :disabled="isDisabled[index]"
                />
                <label class="mb-0" :for="user.userID">{{ user.name }}</label>
              </td>
              <td width="30%">
                <input
                  class="mr-1"
                  type="checkbox"
                  :id="isRequired[index]"
                  v-model="isRequired[index]"
                  :disabled="isDisabled[index]"
                  @change="addRequiredApprover(user, index)"
                />
                <label class="mb-0" :for="isRequired[index]">
                  {{ $t("navigations.required") }}
                </label>
              </td>
              <td width="20%" class="text-center">
                <button
                  @click.prevent="singleSaveApprover(user, index)"
                  :disabled="isDisabled[index]"
                  class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative"
                  type="button"
                  :class="{
                    'disabled-btn-cls': loadingSingleSave[index] == true,
                  }"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingSingleSave[index] == false,
                      'opacity-1': loadingSingleSave[index] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <p
                    class="mb-0"
                    :class="{
                      'opacity-1': loadingSingleSave[index] == false,
                      'opacity-0': loadingSingleSave[index] == true,
                    }"
                  >
                    {{ $t("navigations.save") }}
                  </p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <label v-if="showSave">
          *Unsaved changes will be lost if switching roles.</label
        >

        <button
          v-if="showSave"
          type="button"
          class="save_btn py-1 px-3 position-relative"
          @click="multipleSaveApprover()"
        >
          Save
        </button>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
        v-if="selectedRole.length != 0 && userList.length != 0"
      >
        <p class="my-0">
          *Unsaved changes will be lost if switching designations.
        </p>
        <button
          type="button"
          @click="multiSaveShare('Folder')"
          class="save_btn py-1 px-3 position-relative"
          :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveModalBtn == false,
              'opacity-1': loadingSaveModalBtn == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingSaveModalBtn == false,
              'opacity-0': loadingSaveModalBtn == true,
            }"
          >
            {{ $t("navigations.share") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>

<!-- approver/qc/reviewer details modal starts -->
  <customModal
  v-if="showDetailModal"
  :containersm="true"
  :footerShow="false"
  @closeModal="closeDetailModal"
>
  <template #title>
    <span v-if="selectedDetailType === 'approval'">Approval Details</span>
    <span v-else-if="selectedDetailType === 'review'">Review Details</span>
    <span v-else-if="selectedDetailType === 'qc'">QC Details</span>
  </template>

  <template #body>
    <table class="table table-bordered small">
      <tbody>
        <tr>
          <td><strong>Status :</strong></td>
          <td>{{ selectedDetail?.status || "—" }}</td>
        </tr>
        <tr>
          <td><strong>Comment :</strong></td>
          <td>{{ selectedDetail?.comment || "—" }}</td>
        </tr>
        <tr>
          <td><strong>Date :</strong></td>
          <td>{{ selectedDetail?.date || "—" }}</td>
        </tr>
      </tbody>
    </table>
  </template>
</customModal>
<!-- approver/qc/reviewer details modal ends -->
  <docversionpopup
    v-if="uploadDocumentModal == true"
    :documentTitle="docDetails.documentTitle"
    :description="documentDescription"
    :docid="referenceId"
    @uploadlibactive="uploadDocumentModalClose"
  />

  <manageDocRecipient
    v-if="showDocRecipient"
    :documentStorageId="docDetails.storageId"
    :documentVersionId="docDetails.storageVersionId"
    :documentId="referenceId"
    :docVersion ="passversiontodocusign"
    @closeRecipientModal="showDocRecipient = false"
    @docuSignCreated="docuSignCreated"
  />

  <QcReviewPopup
    v-if="showActionPopup"
    :context= actionType
    :documentId="referenceId"
    
    :versionNo="selectedversionid"
    @close="closeQCReviewModal()"
  />
</template>

<script src="./documentview.js"></script>
<style>
.pdfembeded {
  height: 700px;
  overflow: scroll;
}

.imgwidth {
  max-width: 70vw;
}

.breakWord {
  word-break: break-word;
}

.height-scroll {
  height: 250px;
  overflow-y: auto;
}

.opacity-0 {
  opacity: 0;
}

.custom-tooltip-popups {
  font-size: 0.75rem;
  background: #000;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  position: absolute;
  top: 100%;
  left: 0;
  white-space: nowrap;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tooltip-wrapper:hover .custom-tooltip-popups {
  opacity: 1;
}

.tooltip-below-icon {
  top: 100%;
  /* Position below the icon */
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Perfect center */
  white-space: nowrap;
  background-color: #000;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
}
.btn-assign {
  color: #696969 !important;
  border: 1px solid #696969 !important;
  background: transparent !important;
}

.assign-qc .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 105px;
  top: 25px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.assign-qc:hover .tool-tip,
.assign-qc:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.assign-approver .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 70px;
  top: 25px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.assign-approver:hover .tool-tip,
.assign-approver:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.assign-reviewer .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 140px;
  top: 25px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.assign-reviewer:hover .tool-tip,
.assign-reviewer:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.add-signers .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.7rem;
  right: 35px;
  top: 25px;
  font-size: 0.7rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.add-signers:hover .tool-tip,
.add-signers:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.relative-container {
  position: relative;
  min-height: 100px;
  /* ensures there's space for overlay */
}

.loader-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);
  background: rgba(255, 255, 255, 0.6);
  z-index: 20;
}

.loader-text {
  margin-top: 8px;
  font-size: 0.9rem;
  color: #333;
}

/* Simple CSS spinner */
.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid rgba(0, 0, 0, 0.15);
  border-top-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.etmf-btn{
  border: 1px solid #cccccc;
  border-radius: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  transition: all 0.2s ease-in-out;
  }
.etmf-btn:disabled {
  opacity: 1;
  background-color: transparent;
  color: inherit;
  border-color: #cccccc;
  cursor: not-allowed;
}

 
.custom-badge {
    display: inline-block;
    width: 10px;
    height: 10px;
    position: relative;
  }
  .status-b-radius {
    border-radius: 10px;
  }
  .badge-warning {
    background-color: orange;
  }
  .badge-danger {
    background-color: red;
  }
  .badge-grn {
    background-color: green;
  }

  .tooltip-btn {
  position: relative;
  display: inline-block;
}

.tooltip-btn .tooltip-text {
  visibility: hidden;
  opacity: 0;
  width: max-content;
  background-color: #333;
  color: #fff;
  text-align: left;
  border-radius: 4px;
  padding: 6px 10px;
  position: absolute;
  z-index: 1000;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.3s;
  font-size: 12px;
  white-space: pre-line; 
}

.tooltip-btn:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.more {
  color: #1a73e8;      /* Blue color for "More" */
  cursor: pointer;     /* Show pointer on hover */
  font-weight: 500;    /* Optional: make it slightly bold */
  margin-left: 4px;    /* Optional spacing */
}

.less {
  color: #e91e63;      /* Pink / red for "Less" */
  cursor: pointer;
  font-weight: 500;
  margin-left: 4px;
}

/* Optional: hover effect */
.more:hover,
.less:hover {
  text-decoration: underline;
}


  
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
